import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-info-overlay',
  templateUrl: './info-overlay.component.html',
  styleUrls: ['./info-overlay.component.css']
})
export class InfoOverlayComponent {
  @Input() infoText = '';
  @Output() onClose = new EventEmitter();

  onCloseClick(): void {
    this.onClose.emit();
  }
}
